import { render, staticRenderFns } from "./OnBoardingScreens.vue?vue&type=template&id=2b6fbcb8&"
import script from "./OnBoardingScreens.vue?vue&type=script&lang=js&"
export * from "./OnBoardingScreens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports